export var CSS_BORDER_BOX = "box-sizing: border-box;";